import { render } from "./Panel2.vue?vue&type=template&id=43a7bb04"
import script from "./Panel2.vue?vue&type=script&lang=js"
export * from "./Panel2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__